import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { CopyOutlined, SearchOutlined } from '@ant-design/icons';
import colors from '../../utils/colors';
import {
  CREATED_AT,
  EMAIL,
  FIRST_NAME,
  ID,
  MEMBERSHIP_TYPE,
  SEARCH_BY_EMAIL,
  UNREDEEMED_USERS
} from '../../utils/constants/labels';
import PageHeader from '../common/layout/PageHeader';
import Table from '../common/table/Table';
import { api } from '../../api/api';
import { Input, Tag, Tooltip } from 'antd';
import { debounce } from '../../utils/common';
import { copyToClipboard, DatePreview, membershipTypeColors } from '../../utils/helpers';
import SafeAction from '../common/SafeAction';
import { DATE_FORMAT, formatDate } from '../../utils/timeUtils';

const columns = [
  {
    title: ID,
    dataIndex: 'id',
    sorter: true,
    width: '5%',
    defaultSortOrder: 'descend'
  },
  {
    title: FIRST_NAME,
    dataIndex: 'firstName',
    width: '10%'
  },
  {
    title: EMAIL,
    dataIndex: 'email',
    sorter: true,
    width: '50%'
  },
  {
    title: MEMBERSHIP_TYPE,
    dataIndex: 'membershipType',
    width: '10%',
    render: value => <Tag color={membershipTypeColors[value]}>{value}</Tag>
  },
  {
    title: CREATED_AT,
    dataIndex: 'createdAt',
    sorter: true,
    width: '15%',
    render: value => (value ? <DatePreview>{formatDate(value, DATE_FORMAT)}</DatePreview> : null)
  },
  {
    title: '',
    dataIndex: 'resendInvitation',
    width: '5%',
    render: (value, row) => (
      <SafeAction
        title={'Resend'}
        // we assume that organization users will not be invited to platform as they used to be earlier,
        // but they will sign up by themselves
        action={() => api.resendUserActivation(row.id)}
        doneText={'Sent'}
      />
    )
  },
  {
    title: '',
    dataIndex: 'copyInvitationLink',
    width: '5%',
    render: (value, row) => (
      <Tooltip title="Copy invitation link">
        <CopyOutlined onClick={() => copyToClipboard(`https://app.shovelapp.io/-/set-password/${row.redeemAccessCode}`)} />
      </Tooltip>
    )
  }
];

type Props = {};

const UnredeemedUsers: FC<Props> = ({}) => {
  const [email, setEmail] = useState('');

  const setEmailDebounced = debounce(value => setEmail(value), 400);

  return (
    <Container>
      <PageHeader
        title={UNREDEEMED_USERS}
        extra={[
          <Input
            key={1}
            onChange={e => setEmailDebounced(e.target.value)}
            placeholder={SEARCH_BY_EMAIL}
            prefix={<SearchOutlined />}
          />
        ]}
      />
      <Table
        columns={columns}
        getData={api.getAllUnredeemedUsers}
        idPropName={'id'}
        searchPropName={'email'}
        searchPropValue={email}
      />
    </Container>
  );
};

export default UnredeemedUsers;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  background-color: ${colors.white};
  position: relative;
`;
